import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  REPORTS_FETCH_SUMMARY_CUSTOMER_DATA_BEGIN,
  REPORTS_FETCH_SUMMARY_CUSTOMER_DATA_SUCCESS,
  REPORTS_FETCH_SUMMARY_CUSTOMER_DATA_FAILURE,
  REPORTS_FETCH_SUMMARY_CUSTOMER_DATA_DISMISS_ERROR,
} from './constants';

export function fetchSummaryCustomerData(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_FETCH_SUMMARY_CUSTOMER_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/getSalesSummaryCustomerReport`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_FETCH_SUMMARY_CUSTOMER_DATA_SUCCESS,
            data: {
              data: res.data.data,
              totals: res.data.totals,
              customerSummary: res.data && res.data.summary
            },
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_FETCH_SUMMARY_CUSTOMER_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchSummaryCustomerDataError() {
  return {
    type: REPORTS_FETCH_SUMMARY_CUSTOMER_DATA_DISMISS_ERROR,
  };
}

export function useFetchSummaryCustomerData() {
  const dispatch = useDispatch();

  const { reportsCustomerData, reportsCustomerTotals, customerSummary,fetchSummaryCustomerDataPending, fetchSummaryCustomerDataError } = useSelector(
    state => ({
      reportsCustomerData: state.reports.reportsCustomerData,
      reportsCustomerTotals: state.reports.reportsCustomerTotals,
      customerSummary: state.reports.customerSummary,
      fetchSummaryCustomerDataPending: state.reports.fetchSummaryCustomerDataPending,
      fetchSummaryCustomerDataError: state.reports.fetchSummaryCustomerDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchSummaryCustomerData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchSummaryCustomerDataError());
  }, [dispatch]);

  return {
    reportsCustomerData,
    reportsCustomerTotals,
    customerSummary,
    fetchSummaryCustomerData: boundAction,
    fetchSummaryCustomerDataPending,
    fetchSummaryCustomerDataError,
    dismissFetchSummaryCustomerDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_FETCH_SUMMARY_CUSTOMER_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchSummaryCustomerDataPending: true,
        fetchSummaryCustomerDataError: null,
      };

    case REPORTS_FETCH_SUMMARY_CUSTOMER_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        reportsCustomerData: action.data.data,
        reportsCustomerTotals: action.data.totals,
        customerSummary: action.data.customerSummary,
        fetchSummaryCustomerDataPending: false,
        fetchSummaryCustomerDataError: null,
      };

    case REPORTS_FETCH_SUMMARY_CUSTOMER_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchSummaryCustomerDataPending: false,
        fetchSummaryCustomerDataError: action.data.error,
      };

    case REPORTS_FETCH_SUMMARY_CUSTOMER_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchSummaryCustomerDataError: null,
      };

    default:
      return state;
  }
}
